import {SideNavInterface} from '../../interfaces/side-nav.type';

export const ROUTES: SideNavInterface[] = [
  {
    path: '',
    title: 'RoboF',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'reddit',
    submenu: [
      {
        path: '/roboF/data-preset-list',
        title: 'Cấu hình chung',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'read',
        submenu: []
      },
      {
        path: '/roboF/data-advise-type-list',
        title: 'Cấu hình kiến',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'read',
        submenu: []
      },
      {
        path: '/roboF/age-preset-list',
        title: 'Chấm điểm tuổi',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'read',
        submenu: []
      },
      {
        path: '/roboF/investment-income-preset-list',
        title: 'Chấm điểm thu nhập',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'read',
        submenu: []
      },
      {
        path: '/roboF/financial-level-list',
        title: 'Mức độ tìm hiểu',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'read',
        submenu: []
      },
      {
        path: '/roboF/investment-experience-list',
        title: 'Loại hình tài sản',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'read',
        submenu: []
      },
      {
        path: '/roboF/investment-time-list',
        title: 'Thời gian đầu tư',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'read',
        submenu: []
      },
      {
        path: '/roboF/investment-goal-list',
        title: 'Mục tiêu đầu tư',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'read',
        submenu: []
      },
      {
        path: '/roboF/portfolio-hypothesis-list',
        title: 'Danh mục đầu tư',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'read',
        submenu: []
      },
    ]
  },
  {
    path: '',
    title: 'Smart Portfolio',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'cluster',
    submenu: [
      {
        path: '/smart-portfolio/product',
        title: 'Cặp quỹ',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'control',
        submenu: []
      },
      {
        path: '/smart-portfolio/question',
        title: 'Câu hỏi',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'question',
        submenu: []
      },
      {
        path: '/smart-portfolio/mpe',
        title: 'MPE',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'percentage',
        submenu: []
      },
      {
        path: '/smart-portfolio/config-market',
        title: 'Thị trường chứng khoán',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'line-chart',
        submenu: []
      },
      {
        path: '/smart-portfolio/config-calculate',
        title: 'Thông số tính toán',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'percentage',
        submenu: []
      },
    ]
  },
  {
    path: '',
    title: 'AI Knowledge Base',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'database',
    submenu: [
      {
        path: '/data-AI/BHNT',
        title: 'BHNT',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'control',
        submenu: [
          // {
          //   path: '/data-AI/BHNT/knowledge',
          //   title: 'Kiến thức tư vấn',
          //   iconType: 'nzIcon',
          //   iconTheme: 'outline',
          //   icon: 'line-chart',
          //   submenu: []
          // },
          // {
          //   path: '/data-AI/BHNT/user-case',
          //   title: 'User Cases',
          //   iconType: 'nzIcon',
          //   iconTheme: 'outline',
          //   icon: 'percentage',
          //   submenu: []
          // },
          // {
          //   path: '/data-AI/BHNT/legal',
          //   title: 'Legal & Compliance',
          //   iconType: 'nzIcon',
          //   iconTheme: 'outline',
          //   icon: 'percentage',
          //   submenu: []
          // },
        ]
      },
      {
        path: '/data-AI/fund-data',
        title: 'Quỹ',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'question',
        submenu: []
      },
      {
        path: '/data-AI/healthy-of-financial',
        title: 'Sức khỏe tài chính',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'percentage',
        submenu: []
      },
    ]
  },
];
